export default "__VITE_ASSET__DJML$6c4__"